import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Award, Shield, Users } from 'lucide-react';

const About = () => {
  const features = [
    {
      icon: Award,
      title: 'Certified Professionals',
      description: 'Our technicians are trained and certified in professional window tinting installation.'
    },
    {
      icon: Shield,
      title: 'Premium Materials',
      description: 'We use only the highest quality carbon and ceramic films with superior heat rejection.'
    },
    {
      icon: Users,
      title: 'Industry Leaders',
      description: 'Experienced workers in automotive window tinting excellence.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-gold-600/30 rounded-full blur-3xl"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.7 }}
            className="space-y-6"
          >
            <div className="inline-block">
              <span className="text-gold-500 font-semibold text-sm uppercase tracking-wider">About Us</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              Chicago's Trusted <span className="text-gold-500">Tint Experts</span>
            </h2>
            <p className="text-gray-300 text-lg leading-relaxed">
              Tint Garage is your premier destination for high-performance automotive window tinting. Specializing in advanced carbon and ceramic films, we deliver superior heat rejection, UV protection, and privacy for your vehicle.
            </p>
            <p className="text-gray-300 leading-relaxed">
              At Tint Garage, we understand that window tinting is more than just aesthetics—it's about comfort and protection. Our team of skilled technicians uses state-of-the-art cutting technology to ensure a perfect fit every time, without risking damage to your vehicle's glass or seals.
            </p>
            <p className="text-gray-300 leading-relaxed">
              Whether you're looking for the deep black look of carbon or the maximum heat rejection of ceramic, we have the perfect solution for your ride.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-gradient-to-r from-gold-500/20 to-gold-600/20 rounded-2xl blur-2xl"></div>
            <div className="relative rounded-2xl shadow-2xl overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_tint-masters-chi/artifacts/4bzvklzf_IMG_8488.jpeg" 
                alt="Professional tinting"
                className="w-full h-auto object-cover"
              />
            </div>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
                className="bg-gray-800/30 border border-gray-700 rounded-xl p-6 hover:border-gold-600/50 transition-all duration-300 hover:transform hover:scale-105"
              >
                <div className="w-12 h-12 bg-gold-600/20 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-gold-500" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-gray-400">{feature.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
